import './SearchModal.scss';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { generateLocationName } from 'utils/data';

import Icon from 'components/Icon';
import Modal from 'components/Modal';
import Textbox from 'components/Textbox';
import ActivityIndicator from 'components/ActivityIndicator';

const SearchModal = ({closeModal, handleSelect, show}) => {
    const [isGettingDetails, setIsGettingDetails] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestedLocations, setSuggestedLocations] = useState(null);

    const sessionToken = new window.google.maps.places.AutocompleteSessionToken();
    const autocompleteService = new window.google.maps.places.AutocompleteService();

    const displayLocations = (locations) => {
        console.log(locations);
        setHasSearched(true);
        locations.forEach((l) => l.displayName = generateLocationName(l))
        setSuggestedLocations(locations);
    };

    const handleSearchTermChange = (searchTerm) => {
        setSearchTerm(searchTerm);
        if(searchTerm === '') {
            setSuggestedLocations(null);
            setHasSearched(false);
        } else {
            searchForLocations(searchTerm);
        }
    };

    const searchForLocations = (searchTerm) => {
        autocompleteService.getPlacePredictions({
            fields: ['description'],
            input: searchTerm,
            types: ['(regions)'],
            sessionToken
        },
        displayLocations);
    };

    const handleCancel = () => {
        closeModal();
        setSearchTerm('');
        setHasSearched(false);
        setSuggestedLocations([]);
        setIsGettingDetails(false);
    };

    const handleLocationSelect = (location) => {
        setIsGettingDetails(true);
        const placesService = new window.google.maps.places.PlacesService(document.getElementById('google-attribution'));
        placesService.getDetails({
            fields: ['geometry.location.lat', 'geometry.location.lng'],
            placeId: location.place_id,
            sessionToken
        }, (details) => {
            console.log(details);
            location.lat = details.geometry.location.lat();
            location.lng = details.geometry.location.lng();
            handleSelect(location);
            setTimeout(() => handleCancel(), 200);
        })
    };

    return (
        <Modal
            className="suggested-locations-modal"
            declineButtonOnClick={handleCancel}
            declineButtonText="cancel"
            show={show}
            title="search for a location"
        >
            <Textbox
                className="suggested-locations-search-textbox"
                id="txtAutocompleteSearch"
                label="enter a city or zipcode"
                name="searchTerm"
                onChange={(event) => handleSearchTermChange(event.target.value)}
                placeholder="enter a city or zipcode"
                theme="border"
                value={searchTerm}
            />

            {suggestedLocations ? (
                <>
                    {suggestedLocations.length > 0 ? (
                        <div className="suggested-locations">
                            {suggestedLocations.map((l) => (
                                <div className="suggested-location" key={l.place_id} onClick={() => handleLocationSelect(l)}>
                                    <Icon type="plus" />

                                    <div className="suggested-location__name">
                                        {l.displayName}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : null}
                </>
            ) : null}

            {!suggestedLocations && hasSearched ? (
                <div className="no-suggested-locations">
                    No locations found
                </div>
            ) : null}

            <div id="google-attribution" />

            {isGettingDetails ? <div className="suggested-locations-modal__activity-indicator"><ActivityIndicator/></div> : null}
        </Modal>
    );
};

SearchModal.propTypes = {
    closeModal: PropTypes.func.isRequired,
    handleSelect: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired
};

export default SearchModal;
